"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Supply_API_PATH = exports.SupplyPath = void 0;
const supply = "/supply";
exports.SupplyPath = {
    supply,
};
const api_prefix = "api";
const handlePath = ({ BasePath, path }) => {
    const apiPath = {
        frontend: `${api_prefix}${BasePath}/${path}`,
        backend: `/${path}`,
    };
    return apiPath;
};
exports.Supply_API_PATH = {
    newGasSupply: handlePath({
        BasePath: exports.SupplyPath.supply,
        path: `new`,
    }),
    supplyDelivery: handlePath({
        BasePath: exports.SupplyPath.supply,
        path: `delivery`,
    }),
    newAndDelivery: handlePath({
        BasePath: exports.SupplyPath.supply,
        path: `new_delivery`,
    }),
};
//# sourceMappingURL=supply.js.map